// src/pages/admin/AdminTasksPage.js
import React, { useEffect, useState } from 'react';
import pb from '../../lib/pocketbase';
import AdminLayout from '../../components/admin/AdminLayout';

const statusOptions = [
  { value: 'todo', label: 'À faire' },
  { value: 'in_progress', label: 'En cours' },
  { value: 'done', label: 'Terminé' },
];

function AdminTasksPage() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [filters, setFilters] = useState({ project: '' });

  const fetchTasks = async () => {
    setLoading(true);
    setError('');
    try {
      const q = {};
      if (filters.project.trim()) {
        q.filter = `project = "${filters.project.trim()}"`;
      }
      const res = await pb.collection('tasks').getList(1, 50, {
        sort: '-created',
        ...q,
      });
      setItems(res?.items ?? []);
    } catch (e) {
      setError(e?.message || 'Erreur au chargement des tâches');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTasks();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const applyFilters = async (e) => {
    e?.preventDefault?.();
    await fetchTasks();
  };

  const updateStatus = async (id, status) => {
    try {
      await pb.collection('tasks').update(id, { status });
      setItems((prev) => prev.map((t) => (t.id === id ? { ...t, status } : t)));
    } catch (e) {
      alert(e?.message || 'Erreur lors de la mise à jour du statut');
    }
  };

  return (
    <AdminLayout title="">
      <h1 style={{ marginTop: 0 }}>Tâches</h1>

      <form onSubmit={applyFilters} style={{ display: 'grid', gridTemplateColumns: '1fr auto', gap: 12, alignItems: 'end', margin: '16px 0 24px' }}>
        <div>
          <label>Filtrer par Project ID</label>
          <input type="text" value={filters.project} onChange={(e) => setFilters((f) => ({ ...f, project: e.target.value }))} placeholder="ID projet (optionnel)" />
        </div>
        <div>
          <button type="submit">Appliquer</button>
        </div>
      </form>

      {error && (
        <div style={{ color: '#b91c1c', marginBottom: 12 }}>{error}</div>
      )}

      {loading ? (
        <div>Chargement...</div>
      ) : (
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr>
                <th style={{ textAlign: 'left', borderBottom: '1px solid #e5e7eb', padding: 8 }}>ID</th>
                <th style={{ textAlign: 'left', borderBottom: '1px solid #e5e7eb', padding: 8 }}>Statut</th>
                <th style={{ textAlign: 'left', borderBottom: '1px solid #e5e7eb', padding: 8 }}>Projet</th>
                <th style={{ textAlign: 'left', borderBottom: '1px solid #e5e7eb', padding: 8 }}>Sprint</th>
                <th style={{ textAlign: 'left', borderBottom: '1px solid #e5e7eb', padding: 8 }}>Assigné à</th>
                <th style={{ textAlign: 'left', borderBottom: '1px solid #e5e7eb', padding: 8 }}>Créé</th>
              </tr>
            </thead>
            <tbody>
              {items.map((t) => (
                <tr key={t.id}>
                  <td style={{ borderBottom: '1px solid #f3f4f6', padding: 8 }}>{t.id}</td>
                  <td style={{ borderBottom: '1px solid #f3f4f6', padding: 8 }}>
                    <select value={t.status || ''} onChange={(e) => updateStatus(t.id, e.target.value)}>
                      {statusOptions.map((o) => (
                        <option key={o.value} value={o.value}>{o.label}</option>
                      ))}
                    </select>
                  </td>
                  <td style={{ borderBottom: '1px solid #f3f4f6', padding: 8 }}>{t.project || '-'}</td>
                  <td style={{ borderBottom: '1px solid #f3f4f6', padding: 8 }}>{t.sprint || '-'}</td>
                  <td style={{ borderBottom: '1px solid #f3f4f6', padding: 8 }}>{t.assignee || '-'}</td>
                  <td style={{ borderBottom: '1px solid #f3f4f6', padding: 8 }}>{t.created ? new Date(t.created).toLocaleString() : ''}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </AdminLayout>
  );
}

export default AdminTasksPage;
